import { createReducer, on } from '@ngrx/store';
import * as fromHttp from '../actions/http.action';
import { StateSlice } from '@core/helpers/state-slice';

export type HttpState = StateSlice<string>;

export const initialState: HttpState = {
  data: '',
  loaded: false,
  loading: false,
  error: null,
};

const httpReducer = createReducer(
  initialState,
  on(fromHttp.setHttpHeader, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      loaded: true,
    };
  })
);

export function reducer(
  state: HttpState | undefined,
  action: fromHttp.HttpHeaderActions
) {
  return httpReducer(state, action);
}
